import { render, staticRenderFns } from "./InstitutionRegister.vue?vue&type=template&id=c7c7a048&"
import script from "./InstitutionRegister.vue?vue&type=script&lang=js&"
export * from "./InstitutionRegister.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports